import {action, computed, observable} from 'mobx'
import {stockFilterTags} from 'Components/Screener/stockFilterTags.js'

export class Condition {
  @observable tag
  @observable op
  @observable value
  @observable loadingValueSuggestions = false
  @observable valueSuggestions = []

  constructor(api, {tag = '', op = 'gte', value = ''}) {
    this.api = api
    this.tag = tag
    this.op = op
    this.value = value
  }

  @computed get tagValueType() {
    const tagObj = stockFilterTags.filter(obj => obj.tag === this.tag)
    return tagObj[0]?.units || 'number'
  }

  @action change = (key, value) => {
    if (this.tagValueType === 'string' && this.op !== 'eq') {
      this.op = 'eq'
    }
    if (!(key in this)) {
      return
    }
    this[key] = value
  }

  @action validate() {
    const {tag, op, value} = this
    return tag && op && value
  }

  @action transform() {
    const {tag, op, value} = this
    return {
      tag: tag.toLowerCase().trim().split(' ').join('_'),
      op,
      value
    }
  }

  @action loadValueSuggestions = async () => {
    this.loadingValueSuggestions = true
    try {
      const {data} = await this.api.request(`sys/stock-filters/get-tag-value-suggestions?tag=${this.tag}`, 'get')
      this.valueSuggestions = data
    } finally {
      this.loadingValueSuggestions = false
    }
  }
}
